<!--
Displays opening times for a study space, if this has been provided.

@author cm359n

-->
<template>
  <table class="openingtimes">
    <tr :key="index" v-for="(day, index) in schedule" >
      <td :class="(shortDay(currentDay) == index) ? 'currentday' : 'scheduleday'" v-html="index" />
      <td :class="(shortDay(currentDay) == index) ? 'currentday' : 'scheduleday'">
        <span v-if="day.open">{{ schedDisplay(day) }}</span>
        <span v-if="!day.open"><i>closed</i></span>
      </td>
    </tr>
  </table>
</template>

<script setup>

//Composables
import {useStringUtil} from '@/composables/StringMethods.js'
const {isEmpty, chopSeconds, shortDay} = useStringUtil()

const props = defineProps({
  schedule: Object,
  currentDay: String
})

// TODO move these methods to some common library, maybe StringUtil.js
function schedDisplay (day) {
  let ret = '(none set)'
  if (isEmpty(day.openTime) || isEmpty(day.closeTime)) {
    console.log('Study space is open but opening time or closing time has not been set :-( ')
  } else {
    ret = chopSeconds(day.openTime) + ' - ' + chopSeconds(day.closeTime)
  }
  return ret
}

</script>

<style>
table.openingtimes {
  line-height:13px;
}

td.currentday {
  font-weight: bold;
  font-size: medium;
  color: var(--uog-dark-blue);
}
td.scheduleday {
  font-size: medium;
}
</style>
